module.exports = __webpack_public_path__ + "static/media/end-tour.d15aea15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/end-tour.svg
// module id = 1366
// module chunks = 0